import { useSearchParams } from "react-router";
import Icon404 from "../components/icons/Icon404";
import { STATUS_MSG } from "../constants/messages";
import { API_LINKS } from "../constants/api";
import { createElement } from "react";

export default function PageError({
  msg,
  isLogout,
  msgText,
  redirectToLogin,
}: {
  msg?: string;
  msgText?: string | JSX.Element | JSX.Element[] | undefined;
  isLogout?: boolean;
  redirectToLogin?: boolean;
}) {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const statusCode = status ? parseInt(status) : null;
  const msgTextElement = createElement("div", {
    className: "fw-medium col-12 col-lg-7 mx-auto mt-5",
    dangerouslySetInnerHTML: { __html: msgText },
  });
  const message = msg ? msg : statusCode ? STATUS_MSG[statusCode] : null;
  const hasLogout = statusCode === 400 || statusCode === 401;
  const toLink = redirectToLogin ? "/login" : "/";

  return (
    <div className="container-xxl pt-7 text-center">
      <div className="mb-6">
        {(!message || statusCode === 404) && <Icon404 height={100} />}
      </div>
      <h1 className="display-1 fw-bold">
        {message ? message : "Hov, siden blev ikke fundet!"}
      </h1>
      {msgTextElement ? msgTextElement : ""}
      <div className="mt-5">
        {hasLogout || isLogout ? (
          <a
            href={API_LINKS.logout}
            style={{ border: "none" }}
            className="link-primary fs-4 text-decoration-underline"
          >
            Log ud
          </a>
        ) : (
          <a
            href={toLink}
            className="link-primary fs-4 text-decoration-underline"
          >
            {/* Using anchor-tag instead of router Link, to force a refresh which helps with auth-stuff */}
            Gå til forsiden
          </a>
        )}
      </div>
    </div>
  );
}
